function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.0296 11.8818C9.74882 11.8818 7.89355 9.99558 7.89355 7.6772C7.89355 5.35899 9.74882 3.4728 12.0296 3.4728C14.3101 3.4728 16.1655 5.35899 16.1655 7.6772C16.1655 9.99558 14.3101 11.8818 12.0296 11.8818ZM12.0296 2.04269C8.96051 2.04269 6.46361 4.57032 6.46361 7.6772C6.46361 8.98273 6.9055 10.1849 7.64437 11.1413L2.36636 16.4937C2.05445 16.8101 2.05804 17.3194 2.37445 17.6314C2.53103 17.786 2.73507 17.8629 2.93912 17.8629C3.14676 17.8629 3.3544 17.7831 3.51188 17.6235L8.79908 12.2615C9.71072 12.9216 10.8257 13.3119 12.0296 13.3119C15.0988 13.3119 17.5955 10.7843 17.5955 7.6772C17.5955 4.57032 15.0988 2.04269 12.0296 2.04269Z",
  fill: "#4E597B"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15.6404,
  height: 16,
  fill: "white",
  transform: "translate(2 2)"
})));

var SvgIconSearch = function SvgIconSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIconSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_search.da78b008.svg";
export { ForwardRef as ReactComponent };